var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { pointer: !_vm.disabled, border: _vm.selected },
      staticStyle: {
        width: "36px",
        height: "36px",
        "border-radius": "4px",
        "align-content": "center"
      },
      style: { background: _vm.color, opacity: _vm.disabled ? 0.35 : 1 },
      on: {
        click: function($event) {
          return _vm.onClick()
        }
      }
    },
    [
      _vm.selected
        ? _c("div", [_c("i", { staticClass: "icon fas fa-check-circle" })])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }